export default () => ({
  localesLoaded: [],
  langOptions: [],
  lang: 'ru',
})
